import PropTypes from 'prop-types'

import BarChart from '../../../components/ReusableComponents/BarChart'
import campaignName from '../../../main/campaignNamesAndDesc'
import styles from './CampaignSidebarRate.module.scss'

const CampaignSidebarRate = ({ contentCategory: name, clickRate: percent }) => (
  <div className={styles.container}>
    <div className={styles.text}>
      <span className={styles.name}>{campaignName[name] || name}</span>
      <span className={styles.percent}>{percent}% click</span>
    </div>
    <BarChart percent={percent} />
  </div>
)

CampaignSidebarRate.propTypes = {
  percent: PropTypes.number,
  name: PropTypes.string
}

export default CampaignSidebarRate
